import { StatusBadge } from '@/components/common/StatusBadge'

export function CustomerStatusBadge({ active }: { active: boolean }) {
  return (
    <StatusBadge
      label={active ? 'Aktywny' : 'Nieaktywny'}
      variant={active ? 'success' : 'neutral'}
    />
  )
}
